import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { usePathSegments } from '../../hooks/usePathSegments';
import { DEFAULT_STEP_INDEX } from '../../layouts/OnboardingWizard/consts';
import { buildStepUrl } from '../../layouts/OnboardingWizard/utils';
import {
  isOnboardingWizardAvailable,
  useDeploymentConfig,
} from '../../services/config';
import { ROUTES } from '../consts';

export const OnboardingWizardProtectedRoute = ({
  children,
}: PropsWithChildren) => {
  const config = useDeploymentConfig();
  const pathSegments = usePathSegments();
  const isOnboardingAvailable = isOnboardingWizardAvailable(config);

  if (!isOnboardingAvailable) {
    return <Navigate to={ROUTES.ROOT} replace />;
  }

  const currentStepFromUrl = pathSegments[pathSegments.length - 1];
  const parsedCurrentStep = parseInt(currentStepFromUrl);
  const allowedStepUrlSegment = DEFAULT_STEP_INDEX + 1;

  const isStepFromUrlInvalid =
    isNaN(parsedCurrentStep) || parsedCurrentStep !== allowedStepUrlSegment;

  if (isStepFromUrlInvalid) {
    return <Navigate to={buildStepUrl(DEFAULT_STEP_INDEX)} replace />;
  }

  return <>{children}</>;
};
